export default __webpack_public_path__ + "static/media/ten_of_wands.d107587c.png";